import { render, staticRenderFns } from "./a.vue?vue&type=template&id=4240210d&scoped=true"
import script from "./a.vue?vue&type=script&lang=js"
export * from "./a.vue?vue&type=script&lang=js"
import style0 from "./a.vue?vue&type=style&index=0&id=4240210d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4240210d",
  null
  
)

export default component.exports